import React, { useLayoutEffect } from 'react';
import './region-total.scss';
import i18n from 'i18next';
import { animated } from '@react-spring/web';
import ParametersWidget from '../../common/Parameters';
import { getCurrentWidgetAmount, formatAnimatedNumber, DEFAULT_FONT, LanguageCode, loadGoogleFont, WIDGET_TYPE } from '../../utils';
import { useWidgetData, useAnimatedNumber } from '../../hooks';
import { WidgetAPI } from '../../services';

const RegionTotal = (props: any) => {
  const parameters: ParametersWidget = new ParametersWidget(window.location.search, WIDGET_TYPE.TOTAL);
  const identifier = parameters.getIdentifier() || '';

  const customRegionTotalQueryFn = async () => {
    try {
      const data = await WidgetAPI.getRegionDonation(identifier);
      const { data: widget } = data;

      if (widget && Object.entries(widget?.result).length > 0) {
        return widget.result;
      }
      return null;
    } catch (error) {
      throw error;
    }
  };

  const { data: widgetData } = useWidgetData({
    identifier,
    enabled: !!identifier,
    queryFn: customRegionTotalQueryFn,
  });

  const currentAmount = getCurrentWidgetAmount(
    parameters,
    widgetData?.summary?.protected_size,
    widgetData?.summary?.amount_in_euro,
    widgetData?.summary?.protected_kg_co2,
    widgetData,
  );

  // Use custom animated number hook
  const spring = useAnimatedNumber(currentAmount, {
    duration: 1000,
    config: 'default',
  });

  useLayoutEffect(() => {
    i18n.changeLanguage(parameters.getLanguageValue()?.toLowerCase() || LanguageCode.DE);
    loadGoogleFont(parameters.getFontFamily() || DEFAULT_FONT);
  }, [parameters.getLanguageValue(), parameters.getFontFamily()]);

  return (
    <div className="total-widget">
      <div
        className="last-total w-100 d-flex pb-24"
        style={{
          justifyContent: parameters.getAlignValue(),
          backgroundColor: `#${parameters.getBackgroundColor()}`,
          textAlign: parameters.getAlignValue() as React.CSSProperties['textAlign'],
        }}
      >
        <div className="widget">
          {parameters.getHeadlineValue() && (
            <h3
              className="m-0"
              style={{
                fontWeight: parameters.getHeadlineWeight(),
                color: `#${parameters.getTextColor()}`,
                fontSize: `${parameters.getFontSize()}px`,
                fontFamily: `'${parameters.getFontFamily()}', sans-serif`,
              }}
              dangerouslySetInnerHTML={{ __html: parameters.getHeadlineValue() as string }}
            />
          )}

          <animated.p
            className="m-0 pt-10"
            style={{
              fontWeight: parameters.getValueWeight(),
              color: `#${parameters.getTextColor()}`,
              fontSize: `${parameters.getFontSize()}px`,
              fontFamily: `'${parameters.getFontFamily()}', sans-serif`,
            }}
          >
            {/* Using formatAnimatedNumber to add unit and keep business logic in utils */}
            {spring.number.to((n: number) => formatAnimatedNumber(n, parameters, currentAmount))}
          </animated.p>
        </div>
      </div>
    </div>
  );
};

export default RegionTotal;
